export interface PaymentInclusionExclusionRulesResponseV1 {
  restrictionType: RestrictionType;
  overrideRestriction: boolean;
  restrictionConfigurations: RestrictionConfigurations[];
  applications: ApplicationAccountRestrictions[];
}

export interface ApplicationAccountRestrictions {
  originApplication: string;
  buyerAccountRestrictionEnabled: boolean;
}

export interface PaymentInclusionExclusionPayload {
  tenantId: string;
  buyerAccounts: string[];
}

export interface RestrictionConfigurations {
  restrictionType: RestrictionType;
  buyerAccount: string;
}

export enum RestrictionType {
  Inclusion = 'Inclusion',
  Exclusion = 'Exclusion',
  NoRestriction = 'NoRestriction',
  NoConfigFound = 'No Configuration Found',
}
